module.exports = __webpack_public_path__ + "static/media/cd.a3ecd806.svg";